module.exports = __webpack_public_path__ + "img/thumb_11.5fc92f21.jpg";